import { Outlet } from "react-router";
import { BaseDataPage } from "@/routes/base-data/_components/layout/base-data-page";
import { useFeatureAuth } from "@/services/backend/auth/hooks/use-feature-auth";
import { Alert403 } from "@/shared/components/alerts/alert-403";

/**
 * CompaniesRoute gates the companies base data. The page chrome belongs
 * to the child routes, since the list and a single company do not share
 * a header.
 */
export function CompaniesRoute() {
  const canAccess = useFeatureAuth("gsm.companies.write");
  if (!canAccess) {
    return (
      <BaseDataPage>
        <Alert403 />
      </BaseDataPage>
    );
  }

  return <Outlet />;
}
